import { FunctionComponent, useState } from "react";

import {
  FieldItemStyleProps,
  FieldItemStyles,
  GenericSelectField,
  GenericSelectFieldProps,
  IStyleFunctionOrObject,
  Option,
  Stack,
  Text,
  useTheme
} from "@bps/fluent-ui";
import { Selector } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { useSelectors } from "@libs/api/gateways/field/field-ops-gateway.hooks";

type FormSelectorsSelectProps = Pick<
  GenericSelectFieldProps,
  "required" | "label" | "placeholder"
> & {
  fieldItemStyles?: IStyleFunctionOrObject<
    FieldItemStyleProps,
    FieldItemStyles
  >;
} & { name: string };

export const FormSelectorsSelect: FunctionComponent<FormSelectorsSelectProps> = ({
  name,
  fieldItemStyles,
  required,
  placeholder,
  ...restUsersSelectProps
}) => {
  const theme = useTheme();
  const [search, setSearch] = useState();
  const { isLoading, error, data } = useSelectors({
    name: search
  });

  const options: Option<Selector>[] =
    data
      ?.map(d => ({ key: d.id, text: d.name, data: d }))
      .sort((a, b) => a.text.localeCompare(b.text)) ?? [];

  return (
    <GenericSelectField
      {...restUsersSelectProps}
      name={name}
      fieldItemStyles={fieldItemStyles}
      searchBoxProps={{ onSearch: setSearch }}
      options={options}
      loading={isLoading}
      errorMessage={error?.message}
      styles={{ root: { width: "100%" } }}
      placeholder={placeholder ?? "Please select..."}
      onRenderOption={(option: Option<Selector>) => (
        <Stack>
          <Text>{option.text}</Text>
          {option.data?.name && (
            <Text
              variant="small"
              styles={{ root: { color: theme.palette.themePrimary } }}
            >
              {option.data?.description}
            </Text>
          )}
        </Stack>
      )}
    />
  );
};
